// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialSupplierState,
    SupplierSchema,
    SupplierFormFields,
} from "./Configuration.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
const Supplier = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [supplier, setSupplier] = useState(InitialSupplierState);
    const [formFields, setFormFields] = useState(SupplierFormFields);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "autocomplete")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const getAccounts = async () => {
        spinService.on();
        const response = await get(EntityConstants.ACCOUNTS, "max=all");
        const data = await response.json();
        attachOptions("account_id", data);
        spinService.off();
    };

    const getCurrencies = async () => {
        spinService.on();
        const response = await get(EntityConstants.CURRENCIES, "max=all");
        const data = await response.json();
        attachOptions("currency_id", data);
        spinService.off();
    };

    const getSupplier = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.SUPPLIERS + `/${id}`);
        const data = await response.json();
        setSupplier(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewSupplier = values.id === undefined;
        const url = isNewSupplier ? EntityConstants.SUPPLIERS : EntityConstants.SUPPLIERS + `/${values.id}`;
        const method = isNewSupplier ? post : put;
        const response = await method(url, { supplier: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewSupplier ? MessageContants.SUPPLIER_CREATED : MessageContants.SUPPLIER_UPDATED);
            onClose();
        }
        spinService.off();
    };

    useEffect(() => {
        getAccounts();
        getCurrencies();
        if (id !== undefined) {
            getSupplier(Number(id));
        }
    }, [id]);

    return (
        <Formik
            enableReinitialize
            initialValues={supplier}
            validationSchema={SupplierSchema}
            onSubmit={(values) => handleSubmit(values)}
        >
            {({
                values,
                touched,
                errors,
                dirty,
                isSubmitting,
                handleChange,
                handleBlur,
                handleSubmit,
            }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StyledDrawerForm>
                        <Grid
                            container
                            maxWidth="sm"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                        >
                            {formFields.map((formField, index) => {
                                return (
                                    <Grid key={index} item xs={12} sm={12} md={4} lg={4}>
                                        <GoForm
                                            config={formField}
                                            values={values}
                                            touched={touched}
                                            errors={errors}
                                            handleChange={handleChange}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                        <Box sx={{ p: 2, textAlign: "right" }}>
                            <Button
                                variant="contained"
                                color="error"
                                startIcon={<Iconify icon="eva:close-circle-outline" />}
                                onClick={() => onClose()}
                            >
                                Close
                            </Button>
                            &nbsp;&nbsp;
                            {((values.id === undefined && permissions.has(PermissionConstants.SUPPLIER_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.SUPPLIER_UPDATE))) &&
                                <Button
                                    variant="contained"
                                    startIcon={<Iconify icon="eva:save-fill" />}
                                    type="submit"
                                >
                                    {values.id === undefined ? 'Save' : 'Update'}
                                </Button>
                            }
                        </Box>
                    </StyledDrawerForm>
                </Form>
            )}
        </Formik>
    );
};

Supplier.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default Supplier;
